module.exports = __webpack_public_path__ + "82f1ad231de72c812afa9153f0ce522a.svg";